var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22706",
    "data-name": "Group 22706",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.088,
    height: 13.119,
    viewBox: "0 0 14.088 13.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-link-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3419",
    "data-name": "Rectangle 3419",
    width: 14.088,
    height: 13.119,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22705",
    "data-name": "Group 22705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11735",
    "data-name": "Path 11735",
    d: "M7.447,172.046a.393.393,0,0,0,0,.557,1.64,1.64,0,0,1,0,2.317l-3.356,3.356a1.64,1.64,0,0,1-2.317,0l-.5-.5a1.64,1.64,0,0,1,0-2.317L4.625,172.1a.394.394,0,1,0-.557-.557L.712,174.9a2.423,2.423,0,0,0,0,3.432l.5.5a2.43,2.43,0,0,0,3.432,0L8,175.477a2.43,2.43,0,0,0,0-3.432.393.393,0,0,0-.557,0",
    transform: "translate(0 -166.423)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11736",
    "data-name": "Path 11736",
    d: "M192.3,1.214l-.5-.5a2.43,2.43,0,0,0-3.432,0l-3.356,3.356a2.43,2.43,0,0,0,0,3.432.394.394,0,0,0,.557-.557,1.64,1.64,0,0,1,0-2.317l3.356-3.356a1.64,1.64,0,0,1,2.317,0l.5.5a1.64,1.64,0,0,1,0,2.317l-3.356,3.356a.4.4,0,0,0,.277.674A.384.384,0,0,0,188.942,8L192.3,4.645a2.427,2.427,0,0,0,0-3.432",
    transform: "translate(-178.922 0)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copy-link-icon.a1f26284fb906c0c79feb56ea3505d93.svg";
export { ForwardRef as ReactComponent };